var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5625 9.02734C20.0821 9.02734 20.5 9.48047 20.5 9.96484C20.5 10.5195 20.0821 10.9023 19.5625 10.9023H11.4375V19.0625C11.4375 19.582 11.0196 20 10.4649 20C9.98049 20 9.52737 19.582 9.52737 19.0625V10.9023H1.40237C0.919555 10.9023 0.5 10.5195 0.5 9.96484C0.5 9.48047 0.919555 9.02734 1.40237 9.02734H9.52737V0.9375C9.52737 0.419922 9.98049 0 10.4649 0C11.0196 0 11.4375 0.419922 11.4375 0.9375V9.02734H19.5625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusLarge);
export default __webpack_public_path__ + "static/media/plus-large.c99c7abf9062a16514b95242d807e9b2.svg";
export { ForwardRef as ReactComponent };